// extracted by mini-css-extract-plugin
export default {"tab":"TabButton_tab__5UTyN"};